import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Flame } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setSubscription } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    (async () => {
      if (!sessionId) { navigate("/"); return; }
      try {
        const referred_by = localStorage.getItem("pulsar_ref") || undefined;
        const { data } = await api.session(sessionId, referred_by);
        setUser(data.user);
        setSubscription(data.subscription);
        localStorage.removeItem("pulsar_ref");
      } catch (e) {}
      window.history.replaceState(null, "", "/");
      navigate("/");
    })();
  }, [location, navigate, setUser, setSubscription]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background">
      <div className="flex h-14 w-14 animate-pulse items-center justify-center rounded-2xl bg-red-500 red-glow">
        <Flame size={28} className="text-white" />
      </div>
      <p className="mt-4 text-sm text-zinc-500">Accesso in corso...</p>
    </div>
  );
}
